import { render, staticRenderFns } from "./RoomSettings.vue?vue&type=template&id=2a3a3519&scoped=true&"
import script from "./RoomSettings.vue?vue&type=script&lang=ts&"
export * from "./RoomSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RoomSettings.vue?vue&type=style&index=0&id=2a3a3519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a3519",
  null
  
)

export default component.exports